/** 控制台 · 在线充值（components/topup-panel.tsx、pages/public/topup-terms.tsx），仅海外站。 */
const messages = {
  'panel.title': '充值',
  'panel.description': '向你的专属地址转入稳定币，链上确认后按 1:1 自动计入额度（{currency}）。',
  'panel.loadError': '充值信息加载失败',
  'panel.unavailable': '暂未开放在线充值，请联系运营开通额度。',
  'panel.network': '充值网络',
  'panel.paused': '维护中',
  'panel.getAddress': '获取充值地址',
  'panel.gettingAddress': '正在生成地址…',
  'panel.terms': '充值须知',

  'promo.title': '充值活动',
  'promo.percent': '满 {min} 送 {value}%',
  'promo.percentCap': '满 {min} 送 {value}%，单笔最多送 {cap}',
  'promo.fixed': '满 {min} 送 {value}',
  'promo.firstOnly': '仅首充',
  'promo.until': '截至 {date}',

  'address.title': '{asset} · {network} 充值地址',
  'address.copy': '复制地址',
  'address.copied': '地址已复制',
  'address.qr': '充值地址二维码',
  'address.warnSend': '只转入 {asset}，并且只用 {network} 网络。转错币种或网络的资产无法找回。',
  'address.warnMin': '单笔低于 {min} 不会自动到账，需要人工处理。',
  'address.warnConfirm': '需要 {n} 个区块确认，通常 {eta} 分钟内到账。',
  'address.warnPaused': '该网络维护中，暂停充值。维护期间转入的资产会在恢复后入账。',
  'address.reuse': '这个地址长期属于你的账号，可以重复使用。',

  'terms.dialogTitle': '充值须知',
  'terms.dialogDescription': '第一次充值前，请阅读并同意以下条款。',
  'terms.agree': '我已阅读并同意《充值须知》',
  'terms.accept': '同意并继续',
  'terms.outdated': '须知已更新，请重新阅读。',
  'terms.pageTitle': '充值须知',
  'terms.version': '第 {version} 版',
  'terms.notAvailable': '本站不提供在线充值。',

  'deposits.title': '充值记录',
  'deposits.empty': '还没有充值记录。转账被链上发现后会出现在这里，通常几秒到几分钟。',
  'deposits.loadError': '充值记录加载失败',
  'deposits.time': '时间',
  'deposits.network': '网络',
  'deposits.amount': '金额',
  'deposits.status': '状态',
  'deposits.tx': '交易',
  'deposits.bonus': '赠送 {amount}',
  'deposits.confirmations': '{n}/{total} 确认',

  'status.detected': '确认中',
  'status.confirming': '确认中',
  'status.confirmed': '确认中',
  'status.credited': '已到账',
  'status.below_minimum': '低于最小额，人工处理中',
  'status.unsupported_token': '不支持的代币',
  'status.risk_hold': '审核中',
  'status.reorged': '链上已回滚',
  'status.rejected': '未入账，请联系客服',

  'claim.open': '转账了但没到账？',
  'claim.title': '提交未到账申诉',
  'claim.description': '填写交易哈希，运营核实后会联系你。',
  'claim.network': '转账网络',
  'claim.txHash': '交易哈希',
  'claim.txHashInvalid': '交易哈希格式不正确',
  'claim.note': '补充说明（可选）',
  'claim.notePlaceholder': '例如：转了 50 USDT，从交易所提现',
  'claim.submit': '提交申诉',
  'claim.submitted': '申诉已提交，运营核实后会联系你',
  'claim.failed': '提交申诉失败',
  'address.failed': '获取充值地址失败',
  'terms.failed': '同意充值须知失败',
};

export default messages;
